export const query = `query getCategoryInitialDataWithCategoryDataAlwaysFetchCategories($externalId: String!, $currentCategoryId: String!, $withRichContentDescription: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    filters(enabledFilters: "CATEGORY") {
      filterType
      name
      field
      values {
        key
        value
      }
    }
    categories {
      list {
        id
        name
        slug
        visible
        parentCategoryId
        parentCategoryIndex
      }
    }
    category(categoryId: $currentCategoryId) {
      id
      name
      slug
      visible
      numOfProducts
      description
      richContentDescription @include(if: $withRichContentDescription)
      promotions {
        position
      	promotion {
          id
          destinationUrl
          media {
            image {
              id
              url
              height
              width
              altText
            }
          }
        }
      }
      media {
        url
        fullUrl
        mediaType
        width
        height
      }
      breadcrumbs {
        id
        name
        slug
      }
      seoData
      parentCategoryId
      parentCategoryIndex
      
    }
    allProductsCategoryId
  }
}
`;
